import { SearchInputWithRecent } from "@editor/components/search-input-with-recent";
import debounce from "lodash.debounce";
import { useCallback, useEffect, useState } from "react";
import { useMediaLibPanelStoreShallow } from "../stores/media-lib-panel.store";

export const MediaLibPanelSearchInput = () => {
  "use no memo";
  const { searchQuery, setSearchQuery } = useMediaLibPanelStoreShallow((s) => ({
    searchQuery: s.searchQuery,
    setSearchQuery: s.setSearchQuery,
  }));
  const [queryRaw, setQueryRaw] = useState(searchQuery);
  const [prevSearchQuery, setPrevSearchQuery] = useState(searchQuery);

  if (searchQuery !== prevSearchQuery) {
    setPrevSearchQuery(searchQuery);
    setQueryRaw(searchQuery);
  }

  const updateSearchQuery = useCallback(
    debounce((value: string) => {
      setSearchQuery(value);
    }, 500),
    [setSearchQuery],
  );

  useEffect(() => {
    return () => {
      updateSearchQuery.cancel();
    };
  }, [updateSearchQuery]);

  return (
    <div className="tw-z-20 tw-px-6 -sm:tw-px-3">
      <SearchInputWithRecent
        placeholder="Search files"
        value={queryRaw}
        onChange={(e) => {
          const value = e.target.value;
          setQueryRaw(value);
          if (value.length === 0) {
            setSearchQuery(value);
          } else updateSearchQuery(value);
        }}
        onSubmit={(value) => {
          setSearchQuery(value);
          setQueryRaw(value);
        }}
        onClear={() => {
          setSearchQuery("");
          setQueryRaw("");
        }}
        storageKey="sd-media-lib-panel-recent-search"
        isProcessing={searchQuery !== queryRaw}
        amountOfStoredSearches={3}
      />
    </div>
  );
};
